import React from 'react';
import OpenChargesList from "../../common/OpenCharges";
import Propertii from "../../common/Propertii";

class OpenCharges extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - An interface that allows the landlord to add, edit, and delete a tenant's open charges.
     */
    render() {

        return(
            <React.Fragment>

                <OpenChargesList propertyLeaseId={this.props.match.params.propertyLeaseId} userSession={this.props.userSession}/>

            </React.Fragment>
        )
    };
}

export default OpenCharges;